/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesDocumentsGeoTarget } from './FxIdDomainEntitiesDocumentsGeoTarget';
import {
    instanceOfFxIdDomainEntitiesDocumentsGeoTarget,
    FxIdDomainEntitiesDocumentsGeoTargetFromJSON,
    FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped,
    FxIdDomainEntitiesDocumentsGeoTargetToJSON,
} from './FxIdDomainEntitiesDocumentsGeoTarget';

/**
 * @type FxIdDomainEntitiesDocumentsDocumentGeo
 * Гео-таргетинг для этой конкретной версии.
 * @export
 */
export type FxIdDomainEntitiesDocumentsDocumentGeo = FxIdDomainEntitiesDocumentsGeoTarget;

export function FxIdDomainEntitiesDocumentsDocumentGeoFromJSON(json: any): FxIdDomainEntitiesDocumentsDocumentGeo {
    return FxIdDomainEntitiesDocumentsDocumentGeoFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentGeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsDocumentGeo {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsGeoTarget(json)) {
        return FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainEntitiesDocumentsDocumentGeoToJSON(json: any): any {
    return FxIdDomainEntitiesDocumentsDocumentGeoToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentGeoToJSONTyped(value?: FxIdDomainEntitiesDocumentsDocumentGeo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesDocumentsGeoTarget(value)) {
        return FxIdDomainEntitiesDocumentsGeoTargetToJSON(value as FxIdDomainEntitiesDocumentsGeoTarget);
    }

    return {};
}

